export default "__VITE_ASSET__DYTi_Hm5__"